import React, { FC, useEffect } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import ncNanoId from "utils/ncNanoId";
import NextPrev from "shared/NextPrev/NextPrev";
import CountryCard from "./CountryCard";

export interface CountriesSectionProps {
  className?: string;
  heading?: string;
  subHeading?: string;
  categories?: any[];
  itemPerRow?: 4 | 5;
  sliderStyle?: "style1" | "style2";
}

const CountriesSection: FC<CountriesSectionProps> = ({
  heading = "Destinasi",
  subHeading = "Temukan trip dan guide pribadi di negara favorit kamu",
  className = "",
  categories = [],
  itemPerRow = 5,
  sliderStyle = "style1",
}) => {
  const UNIQUE_CLASS = "glide_" + ncNanoId();

  useEffect(() => {
    if (document.querySelector(`.${UNIQUE_CLASS}`)) {
      new Glide(`.${UNIQUE_CLASS}`, {
        perView: itemPerRow,
        gap: 32,
        bound: true,
        breakpoints: {
          1280: {
            perView: itemPerRow - 1,
          },
          1024: {
            gap: 20,
            perView: itemPerRow - 1,
          },
          768: {
            gap: 20,
            perView: itemPerRow - 2,
          },
          640: {
            gap: 20,
            perView: itemPerRow - 3,
          },
          500: {
            gap: 20,
            perView: 2,
          },
        },
      }).mount();
    }
  }, []);

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`}>
        {categories != null && categories.length > 0 ?
          <Heading
            desc={subHeading}
            hasNextPrev={sliderStyle === "style1"}
            isCenter={sliderStyle === "style2"}
            nextPrevClassName="hidden md:block"
          >
            {heading}
          </Heading>
          : <div></div>}
        <div className="glide__track " data-glide-el="track">
          <ul className="glide__slides">
            {categories.map((item, index) => item.numberOfGuide >= 1 && (
              <li key={index} className={`glide__slide`}>
                <CountryCard key={ncNanoId()} item={item} />
              </li>
            ))}
          </ul>
        </div>

        {sliderStyle === "style2" && (
          <NextPrev className="justify-center mt-16" />
        )}
      </div>
    </div>
  );
};

export default CountriesSection;
